import * as React from "react"
import type { Theme } from "types/theme"
import { changeStyleSheetUrl } from "./helpers"

type Props = {
  children?: React.ReactNode
}

type ThemeContextType = {
  theme: Theme
  changeTheme: React.Dispatch<Theme>
}

const ThemeContext = React.createContext<ThemeContextType | undefined>(undefined)

const ThemeProvider = ({ children }: Props) => {
  const [theme, setTheme] = React.useState<Theme>("dim")

  const changeTheme = (newTheme: Theme) => {
    setTheme(newTheme)
    changeStyleSheetUrl("layout-css", `layout-${newTheme}.css`, 1)
    changeStyleSheetUrl("theme-css", `theme-${newTheme}.css`, 1)
  }

  // set initial stylesheet
  React.useEffect(() => {
    changeTheme(theme)
  }, [])

  const value = { theme, changeTheme }

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

const useTheme = () => {
  const context = React.useContext(ThemeContext)

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider")
  }

  return context
}

export { ThemeProvider, useTheme }
